import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { collection, addDoc } from 'firebase/firestore';
import { Grid } from '@mui/material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { db } from './firebase';

const initialValues = {
  companyName: '',
  fullName: '',
  email: '',
  linkedIn: '',
  twitter: '',
};

export default function AddLayoff({ user }) {
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = useState(initialValues);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, 'layoff_data'), values);
      setOpen(false);
    } catch (err) { /* empty */ }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<AddOutlinedIcon />} onClick={handleClickOpen}>
        ADD INFO
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Please enter the below details</DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={2} alignItems>
            <Grid item xs={12} className="mt-5">
              <TextField name="companyName" label="Company Name" variant="outlined" fullWidth onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField name="fullName" defaultValue={user.name} label="Full Name" variant="outlined" fullWidth onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField name="email" defaultValue={user.email} label="Email" variant="outlined" fullWidth onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField name="linkedIn" label="Linked In" variant="outlined" fullWidth onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField name="twitter" label="Twitter" variant="outlined" fullWidth onChange={handleInputChange} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
